/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Infrastructure_For_SovereigntyInputs */

const en_infrastructure_for_sovereignty = /** @type {(inputs: Infrastructure_For_SovereigntyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Infrastructure for Sovereignty`)
};

const es_infrastructure_for_sovereignty = /** @type {(inputs: Infrastructure_For_SovereigntyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Infraestructura para la soberanía`)
};

const fr_infrastructure_for_sovereignty = /** @type {(inputs: Infrastructure_For_SovereigntyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une infrastructure pour l'indépendance`)
};

const de_infrastructure_for_sovereignty = /** @type {(inputs: Infrastructure_For_SovereigntyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Infrastruktur für Souveränität`)
};

const ja_infrastructure_for_sovereignty = /** @type {(inputs: Infrastructure_For_SovereigntyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`独立のためのインフラ`)
};

const zh_infrastructure_for_sovereignty = /** @type {(inputs: Infrastructure_For_SovereigntyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为独立自主打造的基础设施`)
};

const ar_infrastructure_for_sovereignty = /** @type {(inputs: Infrastructure_For_SovereigntyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بنية تحتية للاستقلالية`)
};

const id_infrastructure_for_sovereignty = /** @type {(inputs: Infrastructure_For_SovereigntyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Infrastruktur untuk Kedaulatan`)
};

const it_infrastructure_for_sovereignty = /** @type {(inputs: Infrastructure_For_SovereigntyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Infrastruttura per la Sovranità`)
};

const ru_infrastructure_for_sovereignty = /** @type {(inputs: Infrastructure_For_SovereigntyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Инфраструктура для независимости`)
};

const pt_infrastructure_for_sovereignty = /** @type {(inputs: Infrastructure_For_SovereigntyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Infraestrutura para Soberania`)
};

const ko_infrastructure_for_sovereignty = /** @type {(inputs: Infrastructure_For_SovereigntyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`독립성을 위한 인프라`)
};

/**
* | output |
* | --- |
* | "Infrastructure for Sovereignty" |
*
* @param {Infrastructure_For_SovereigntyInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const infrastructure_for_sovereignty = /** @type {((inputs?: Infrastructure_For_SovereigntyInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Infrastructure_For_SovereigntyInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_infrastructure_for_sovereignty(inputs)
	if (locale === "es") return es_infrastructure_for_sovereignty(inputs)
	if (locale === "fr") return fr_infrastructure_for_sovereignty(inputs)
	if (locale === "de") return de_infrastructure_for_sovereignty(inputs)
	if (locale === "ja") return ja_infrastructure_for_sovereignty(inputs)
	if (locale === "zh") return zh_infrastructure_for_sovereignty(inputs)
	if (locale === "ar") return ar_infrastructure_for_sovereignty(inputs)
	if (locale === "id") return id_infrastructure_for_sovereignty(inputs)
	if (locale === "it") return it_infrastructure_for_sovereignty(inputs)
	if (locale === "ru") return ru_infrastructure_for_sovereignty(inputs)
	if (locale === "pt") return pt_infrastructure_for_sovereignty(inputs)
	return ko_infrastructure_for_sovereignty(inputs)
});